export default "__VITE_ASSET__Ce5W2BXp__"